import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Icon, NewButton } from '../../../../../components';

const DataDictionaryTabsContainer = styled.nav`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const DataDictionaryTabs = ({
  onViewChange,
  isTermTranslationsTabAvailable = false,
  isMetricsTabAvailable = false,
  activeView = 'sources'
}) => (
  <DataDictionaryTabsContainer>
    <NewButton tertiary active={activeView === 'sources'} onClick={() => onViewChange('sources')}>
      <Icon name='source' />
      Sources
    </NewButton>
    {isTermTranslationsTabAvailable && (
      <NewButton
        tertiary
        active={activeView === 'termTranslations'}
        onClick={() => onViewChange('termTranslations')}
      >
        <Icon name='insight' />
        Business logic
      </NewButton>
    )}
    {isMetricsTabAvailable && (
      <NewButton tertiary active={activeView === 'metrics'} onClick={() => onViewChange('metrics')}>
        <Icon name='hashtag' size={20} displaySize={24} />
        Metrics
      </NewButton>
    )}
  </DataDictionaryTabsContainer>
);

DataDictionaryTabs.propTypes = {
  activeView: PropTypes.string,
  onViewChange: PropTypes.func.isRequired,
  isTermTranslationsTabAvailable: PropTypes.bool,
  isMetricsTabAvailable: PropTypes.bool
};

export { DataDictionaryTabs };
